import state from './moduleForecastWindyState.js'
import mutations from './moduleForecastWindyMutations.js'
import actions from './moduleForecastWindyActions.js'
import getters from './moduleForecastWindyGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
